import { gql } from '@parkchirp/api-client';

export const CREATE_FEE = gql`
  mutation createFee(
    $feeName: String!
    $feeTypeId: Int!
    $type: FeeTypeEnum!
    $facilityId: ID!
    $calculationType: FeeCalculationTypeEnum!
    $feesHistory: [FeeHistoryInput]!
    $accessDeviceTypeId: Int
    $isChildRateFixedFee: Boolean
  ) {
    createFee(
      feeName: $feeName,
      feeTypeId: $feeTypeId,
      type: $type,
      facilityId: $facilityId,
      calculationType: $calculationType,
      feesHistory: $feesHistory,
      accessDeviceTypeId: $accessDeviceTypeId
      isChildRateFixedFee: $isChildRateFixedFee
    )
  }
`;
